import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  GET_ALL_STATIC_PAGES,
  CREATE_STATIC_PAGE,
  UPDATE_STATIC_PAGE,
  DELETE_STATIC_PAGE,
} from "./actionTypes"
import {
  getAllStaticPagesCall,
  createStaticPageCall,
  updateStaticPageCall,
  deleteStaticPageCall,
  API_URL,
} from "../../helpers/repository"
import { getAllStaticPages, getAllStaticPagesResponseSuccess } from "./actions"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"

function* attemptGetAllStaticPages() {
  try {
    const response = yield call(getAllStaticPagesCall)
    yield put(getAllStaticPagesResponseSuccess(response.data.data))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateStaticPage(action) {
  const { history } = action
  try {
    const response = yield call(createStaticPageCall, action.payload)
    showMessage("success", response.data.message)
    history.push("/crm/static-pages")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditPromotion(action) {
  const { history, redirectTo } = action
  try {
    const response = yield call(updateStaticPageCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllStaticPages())
    history.push(`/crm/static-pages`)
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeletePromotion(action) {
  try {
    const response = yield call(deleteStaticPageCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllStaticPages())
  } catch (error) {
    showErrorMessages(error)
  }
}

function* StaticPagesSaga() {
  yield takeEvery(GET_ALL_STATIC_PAGES, attemptGetAllStaticPages)
  yield takeEvery(CREATE_STATIC_PAGE, attemptCreateStaticPage)
  yield takeEvery(UPDATE_STATIC_PAGE, attemptEditPromotion)
  yield takeEvery(DELETE_STATIC_PAGE, attemptDeletePromotion)
}

export default StaticPagesSaga
